var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ml-3" }, [
    _c("div", { staticClass: "row" }, [
      !_vm.node.isLeaf
        ? _c("i", {
            class: _vm.node.icon,
            on: {
              click: function($event) {
                return _vm.onIconClicked($event, _vm.node)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.node.isLeaf
        ? _c("p", { staticClass: "concept-label m-0" }, [_vm._v("-- ")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "concept-label ml-1",
          on: {
            click: function($event) {
              return _vm.onNodeClicked($event, _vm.node)
            }
          }
        },
        [_vm._v("\n     " + _vm._s(_vm.getLabelOrId(_vm.node)))]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      _vm._l(_vm.node.children, function(child) {
        return _vm.node.resolved && !_vm.node.collapsed
          ? _c("class-tree", { key: child.label, attrs: { node: child } })
          : _vm._e()
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68b58236", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68b58236","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassTree.vue
// module id = null
// module chunks = 